import { useTranslation } from 'react-i18next';

import { BlueButton, WhiteButton } from 'libs/ui';
import { Content } from './bsk-confirm.styled';

export const BskConfirm = ({ cancel, ok, error }) => {
  const { t } = useTranslation();

  if (error) {
    return (
      <Content>
        <div>
          <div>{t('messages.Не удалось выдать БСК')}</div>
          <div
            style={{
              display: 'flex',
              marginTop: '20px',
              justifyContent: 'space-evenly',
            }}
          >
            <BlueButton onClick={cancel}>{t('buttons.Закрыть')}</BlueButton>
          </div>
        </div>
      </Content>
    );
  }

  return (
    <Content>
      <div>
        <div>{t('messages.Подтвердите выдачу БСК')}</div>
        <div
          style={{
            display: 'flex',
            marginTop: '20px',
            justifyContent: 'space-evenly',
          }}
        >
          <WhiteButton onClick={cancel} style={{ marginRight: '10px' }}>
            {t('buttons.Отменить')}
          </WhiteButton>
          <BlueButton onClick={ok}>{t('buttons.Выдать')}</BlueButton>
        </div>
      </div>
    </Content>
  );
};
